import { Navigate } from "react-router-dom";

const DashboardIndexRedirect = () => {
  return <Navigate to="/dashboard/general" replace />;
};

export default DashboardIndexRedirect;
